import { InputHTMLAttributes, forwardRef } from "react";
import clsx from "clsx";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className, id, ...rest }, ref) => {
    const inputId = id || rest.name;
    return (
      <div className="flex flex-col gap-1.5">
        {label && (
          <label
            htmlFor={inputId}
            className="text-xs font-medium uppercase tracking-wider text-text-secondary"
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={clsx(
            "rounded-md border border-border bg-bg-panel px-3 py-2 text-sm text-text-primary",
            "placeholder:text-text-muted focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent",
            "transition-colors",
            error && "border-bear focus:border-bear focus:ring-bear",
            className
          )}
          {...rest}
        />
        {error && <p className="text-xs text-bear">{error}</p>}
      </div>
    );
  }
);
Input.displayName = "Input";
